import React from 'react';
import { motion } from 'framer-motion';
import { ArrowUpRight } from 'lucide-react';
interface ProjectCardProps {
  title: string;
  client: string;
  industry: string;
  summary: string;
  delay?: number;
  onClick?: () => void;
}
export function ProjectCard({
  title,
  client,
  industry,
  summary,
  delay = 0,
  onClick
}: ProjectCardProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true
  }} transition={{
    duration: 0.5,
    delay
  }} onClick={onClick} className="group cursor-pointer bg-white rounded-2xl overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300 border border-slate-100 flex flex-col h-full" data-id="element-118">
      {/* Image Placeholder with Gradient */}
      <div className="h-48 bg-navy-900 relative overflow-hidden" data-id="element-119">
        <div className="absolute inset-0 bg-gradient-to-br from-navy-800 to-navy-900 opacity-90" data-id="element-120" />
        <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/cubes.png')] opacity-10 mix-blend-overlay" data-id="element-121" />

        {/* Hover Overlay */}
        <div className="absolute inset-0 bg-tech-blue/80 opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-center justify-center backdrop-blur-sm" data-id="element-122">
          <div className="w-12 h-12 rounded-full bg-white flex items-center justify-center transform translate-y-4 group-hover:translate-y-0 transition-transform duration-300" data-id="element-123">
            <ArrowUpRight className="w-6 h-6 text-tech-blue" data-id="element-124" />
          </div>
        </div>

        <div className="absolute top-4 left-4" data-id="element-125">
          <span className="px-3 py-1 text-xs font-semibold bg-white/10 text-white backdrop-blur-md rounded-full border border-white/20" data-id="element-126">
            {industry}
          </span>
        </div>
      </div>

      <div className="p-6 flex-grow flex flex-col" data-id="element-127">
        <div className="text-sm font-medium text-tech-blue mb-2" data-id="element-128">{client}</div>
        <h3 className="text-xl font-bold text-navy-900 mb-3 group-hover:text-tech-blue transition-colors" data-id="element-129">
          {title}
        </h3>
        <p className="text-slate-600 text-sm leading-relaxed mt-auto" data-id="element-130">
          {summary}
        </p>
      </div>
    </motion.div>;
}